module.exports = __webpack_public_path__ + "static/media/leaf.90735cb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/bfile_result/leaf.svg
// module id = 2999
// module chunks = 0